import { changeTone, formatChange, Icon, type Polarity } from '@/design'

/** An inline "+12.3% vs previous 30 days", coloured by what the change means. */
export function ChangeText({
  change,
  polarity = 'up_good',
  label,
}: {
  change: number | null
  polarity?: Polarity
  label?: string | null
}) {
  if (change === null) return null
  const tone = changeTone(change, polarity)
  return (
    <span className="ov-change" data-tone={tone}>
      {change !== 0 ? <Icon name={change > 0 ? 'arrowUp' : 'arrowDown'} size={12} /> : null}
      {formatChange(change)}
      {label ? <span className="ov-change__label"> {label}</span> : null}
    </span>
  )
}
